import classes from './Discovery.module.css'

import {  postMessage } from '../../../../../store/chatAi-actions';
import { useDispatch, useSelector } from 'react-redux';


function Discovery() {
    const disptach = useDispatch()
    const { texts } = useSelector(state => state.translate);

    return (
        <div className={classes.DiscoveryContainer}>
            <button alt={texts.discoveryHealthyLifestyleOption} className={classes.Discovery} onClick={() => disptach(postMessage(texts.discoveryHealthyLifestyleMessage,{}))}>
                <div className={classes.DiscoveryLifestyleImage}/>
                <div className={classes.DiscoveryText}>
                    {texts.discoveryHealthyLifestyleOption}
                </div>
            </button>
            <button alt={texts.discoveryBlessSomeoneOption} className={classes.Discovery} onClick={() => disptach(postMessage(texts.discoveryBlessSomeoneMessage,{}))}>
                <div className={classes.DiscoveryBlessingImage}/>
                <div className={classes.DiscoveryText}>
                    {texts.discoveryBlessSomeoneOption}
                </div>
            </button>
            <button alt={texts.discoveryProjectOption} className={classes.Discovery} onClick={() => disptach(postMessage(texts.discoveryProjectMessage,{}))}>
                <div className={classes.DiscoveryProjectImage}/>
                <div className={classes.DiscoveryText}>
                    {texts.discoveryProjectOption}
                </div>
            </button>
            <button alt={texts.discoveryPresentationOption} className={classes.Discovery} onClick={() => disptach(postMessage(texts.discoveryPresentationMessage,{}))}>
                <div className={classes.DiscoveryPresentationImage}/>
                <div className={classes.DiscoveryText}>
                    {texts.discoveryPresentationOption}
                </div>
            </button>
        </div>
    );
}

export default Discovery;